import { Grid } from '@mui/material';
import React from 'react';
import ReactGA from 'react-ga4';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import DevMenu from './components/DevMenu';
import Base from './pages/Base';
import Redirects from './pages/Redirects';
import ScrollToTop from './utilities/ScrollToTop';

const devMenu = process.env.NODE_ENV === 'development' &&
  process.env.REACT_APP_MOCK_API === 'true' && <DevMenu />;

ReactGA.initialize('G-GMR43SBE9K');

const App = (): JSX.Element => (
  <Grid container className="container-fluid wrapper">
    <Grid item xs={12} justifyItems="center" alignItems="center">
      <BrowserRouter>
        <ScrollToTop />
        {devMenu}
        <Routes>
          <Route path="/invoice/:invoiceId" element={<Base page="Summary" />} />
          <Route
            path="/invoice/:invoiceId/address"
            element={<Base page="Billing" />}
          />
          <Route
            path="/invoice/:invoiceId/pay"
            element={<Base page="Payment" />}
          />
          <Route
            path="/invoice/:invoiceId/confirmation"
            element={<Base page="Confirmation" />}
          />
          <Route path="/invoice/:invoiceId/*" element={<Redirects />} />
          <Route path="*" element={<Redirects />} />
        </Routes>
      </BrowserRouter>
    </Grid>
  </Grid>
);

export default App;
